module.exports = __webpack_public_path__ + "static/media/ngoc-trinh-be-9.90a91d9f.jpg";